// Copyright (c) Move Closer 2022.

import { Variant } from '../../../contexts'
import { StarsRateProps } from '../../../dsl/molecules/StarsRate'

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const translateProductVariantToStarsRateProps = (variant: Variant<string>, isBlack: boolean = true): Omit<StarsRateProps, 'model'> => {
  return {
    isDisabled: true,
    allowHalfValues: true,
    rate: 5,
    isLarge: false,
    isBlack
  }
}
